import moment from 'moment';

export const processes = [
  {
    select_no:'',
    machine_id:null,
    tool_id:null,
    gauge_id:null,
    fixture_id:null,
    breakdown_details: '',
    bd_time: null,
    attended_date: null,
    attended_by: '',
    attended_time: null,
    work_completion_date: null,
    work_completion_time: null,
    work_completion_status: null,
    work_completion_verified_by:'',
  },
];

export const initialState = {
  isSubmitted: false,
  is_admin_request_no: null,
  is_admin_request: null,
  report_prepared_by: null,
  report_approved_by: null,
  moduleData_Date: moment(),
  to:"",
  maint_dept:"",
  tool_room_dept:"",
  department_id: null,
  module_time:null,

  //footer
  work_done: '', 
  complaint_by_dept: '',
  received_by_maint: '',
  verified_by_quality: '',
  total_breakdown_time:'',

  processes: Array.from({ length: 1 }, () => ({ ...processes[0] })),
};
